<!--  -->
<template>
  <div class="emptyData">
    <img src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/coll_qs.png" alt="" />
    <p>{{ txtcont }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    txtcont: {
      type: String,
      default: '暂无内容，快去参与活动吧~',
    },
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.emptyData {
  margin: 100px auto 0;
  img {
    display: block;
    width: 370px;
    height: 272px;
    margin: 200px auto 0;
  }
  p {
    width: 100%;
    height: 31px;
    color: #a5a5a5;
    font-weight: 400;
    font-size: 22px;
    line-height: 31px;
    text-align: center;
  }
}
</style>